import React from 'react';
import { useTranslation } from 'react-i18next';
import './FilingProgressBar.css';

const JURISDICTION_FLAGS = {
  AU: '\uD83C\uDDE6\uD83C\uDDFA',
  US: '\uD83C\uDDFA\uD83C\uDDF8',
  EU: '\uD83C\uDDEA\uD83C\uDDFA',
  UK: '\uD83C\uDDEC\uD83C\uDDE7',
  NZ: '\uD83C\uDDF3\uD83C\uDDFF',
  CA: '\uD83C\uDDE8\uD83C\uDDE6',
  SG: '\uD83C\uDDF8\uD83C\uDDEC',
  JP: '\uD83C\uDDEF\uD83C\uDDF5',
  CN: '\uD83C\uDDE8\uD83C\uDDF3',
  KR: '\uD83C\uDDF0\uD83C\uDDF7',
  IN: '\uD83C\uDDEE\uD83C\uDDF3',
  BR: '\uD83C\uDDE7\uD83C\uDDF7',
  MX: '\uD83C\uDDF2\uD83C\uDDFD'
};

const JURISDICTION_NAMES = {
  AU: 'Australia',
  US: 'United States',
  EU: 'European Union',
  UK: 'United Kingdom',
  NZ: 'New Zealand',
  CA: 'Canada',
  SG: 'Singapore',
  JP: 'Japan',
  CN: 'China',
  KR: 'South Korea',
  IN: 'India',
  BR: 'Brazil',
  MX: 'Mexico'
};

function FilingProgressBar({ filing }) {
  const { t } = useTranslation('notifications');

  if (!filing) return null;

  const { jurisdiction, status, ipOfficeRef, filedAt } = filing;

  const getStatusInfo = () => {
    switch (status) {
      case 'registered':
        return { icon: '\u2713', text: t('filingStatus.registered', 'Registered'), color: 'success' };
      case 'accepted':
        return { icon: '\u2713', text: t('filingStatus.accepted', 'Accepted'), color: 'success' };
      case 'filed':
        return { icon: '\u2713', text: t('filingStatus.filed', 'Filed'), color: 'info' };
      case 'pending':
        return { icon: '\u23F3', text: t('filingStatus.pending', 'Pending'), color: 'warning' };
      case 'rejected':
        return { icon: '\u2717', text: t('filingStatus.rejected', 'Rejected'), color: 'error' };
      default:
        return { icon: '\u2022', text: status || t('filingStatus.unknown', 'Unknown'), color: 'default' };
    }
  };

  const statusInfo = getStatusInfo();
  const flag = JURISDICTION_FLAGS[jurisdiction] || '\uD83C\uDFF3\uFE0F';
  const name = JURISDICTION_NAMES[jurisdiction] || jurisdiction;

  return (
    <div className={`filing-progress-bar status-${statusInfo.color}`}>
      <div className="filing-jurisdiction">
        <span className="jurisdiction-flag">{flag}</span>
        <span className="jurisdiction-code">{jurisdiction}</span>
        <span className="jurisdiction-name">{name}</span>
      </div>

      <div className="filing-status">
        <span className={`status-indicator status-${statusInfo.color}`}>
          {statusInfo.icon} {statusInfo.text}
        </span>
      </div>

      {ipOfficeRef && (
        <div className="filing-ref">
          <span className="ref-label">{t('filings.refNumber', 'Ref')}:</span>
          <span className="ref-value">{ipOfficeRef}</span>
        </div>
      )}

      {filedAt && (
        <div className="filing-date">
          {new Date(filedAt).toLocaleDateString()}
        </div>
      )}
    </div>
  );
}

export default FilingProgressBar;
